import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { prop, path, pathOr, identity, equals } from "ramda";

import { SINGLE_PER_PAGE, DOUBLE_PER_PAGE } from "~/constants/page-modes";

// Actions
export const SWITCH_PAGE_MODE_PAGE = "APP@PAGE::SWITCH_MODE";

// Action Creators
export const setPageMode = createAction(SWITCH_PAGE_MODE_PAGE);

// Selectors
const getPage = path(["application", "page"]);

export const selectPage = createSelector(getPage, identity);

export const selectPageMode = createSelector(getPage, prop("mode"));

export const selectIsSinglePage = createSelector(
  selectPageMode,
  equals(SINGLE_PER_PAGE)
);

export const selectIsDoublePage = createSelector(
  selectPageMode,
  equals(DOUBLE_PER_PAGE)
);

// Initial State
const initialState = () => ({
  mode: pathOr(
    DOUBLE_PER_PAGE,
    ["book", "initial", "pageMode"],
    window.getClientConfiguration()
  )
  // Print-Seitenzahl
  // humanReadable
  // relative: 1
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SWITCH_PAGE_MODE_PAGE:
      return { ...state, mode: action.payload };
    default:
      return state;
  }
}
